import React from 'react';
import classess from './CustomImage.module.scss'

const CustomImage = ({ title, className = '', lazy = false, images = [], defaultImg }) => {
    return (
        <picture>
            {images.map((img, index) => (
                <source
                    key={index}
                    media={`(max-width: ${img.media}px)`}
                    srcSet={img.src}
                />
            ))}
            <img
                className={className}
                src={defaultImg}
                alt={title}
                loading={lazy ? 'lazy' : 'eager'}
            />
        </picture>
    );
};

export default CustomImage;
